@if (displayAsDialog) {
  <nb-card>
    @if (title && !selectionMode) {
      <nb-card-header>
        <span [innerHTML]="'Linked documents to {element}' | translate: {element: title}"></span>
      </nb-card-header>
    }
    <nb-card-body>
      @if (selectionMode) {
        <div style="display:flex; justify-content:flex-end; padding:0 0 8px; flex-shrink:0;">
          <span class="close-drawer-btn" (click)="close()">
            <i class="fa-light fa-x"></i>
          </span>
        </div>
      }
      <ag-grid-angular class="ag-theme-balham ag-grid-documents" [gridOptions]="gridOptions" [nbSpinner]="loading"></ag-grid-angular>
    </nb-card-body>
    @if (investIds.length && fromWorkflow) {
      <nb-card-footer>
        <button (click)="addNewDocument()" class="add-btn">
          + <span class="btn-text">{{ 'Add a document' | translate }}</span>
        </button>
      </nb-card-footer>
    }
  </nb-card>
} @else {
  <div class="table-no-dialog">
    <div class="grid-wrapper">
      <ng-container *ngTemplateOutlet="table"></ng-container>
    </div>
    <button class="add-document-fab" (click)="addNewDocument()" [title]="'Add a document' | translate">
      <i class="fa-thin fa-plus fa-2x"></i>
    </button>
  </div>
}

<ng-template #table>
  <ag-grid-angular class="ag-theme-balham ag-grid-documents" [gridOptions]="gridOptions" [nbSpinner]="loading"></ag-grid-angular>
</ng-template>
